(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
const activeMediaTemplate = activeMedia.querySelector('template');
const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

const container = this.querySelector('[role="document"]');
container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-wholesale"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locations-tab-section"] && !window.DesignMode) return;
  try {
    
  const tabButtons = document.querySelectorAll(".iaro-split-section__meta__tabs-list__item > button");

  tabButtons.forEach((tabButton) => {
    tabButton.addEventListener("click", (e) => {
      const sectionId = e.target.getAttribute("data-section-id");
      const panelId = e.target.getAttribute("data-for-panel-id");

      const allButtons = Array.from(document.querySelectorAll(`.iaro-split-section__meta__tabs-list__item > button[data-section-id="${sectionId}"]`));
      const allTabs = Array.from(document.querySelectorAll(`.iaro-split-section__tab[data-section-id="${sectionId}"]`));

      const activeButton = allButtons
        .filter((button) => button.getAttribute("data-for-panel-id") === panelId)[0];
      const activeTab = allTabs
        .filter((tab) => tab.getAttribute("data-panel-id") === panelId)[0];

      allButtons.forEach((button) => button.parentElement.classList.remove("active"));
      allTabs.forEach((tab) => tab.classList.remove("active"));

      activeButton.parentElement.classList.add("active");
      activeTab.classList.add("active");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hero"] && !window.DesignMode) return;
  try {
    
(function() {
  function htmlToTypedStructure(html) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var textNodes = [];

    function isWhitespaceOnly(str) {
      return !str || /^[\s\u00A0]+$/.test(str);
    }

    function cloneNodeWithEmptyText(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        var full = node.nodeValue || '';
        full = full.replace(/[ \t\r\n]+/g, ' ');
        if (isWhitespaceOnly(full)) {
          full = full.length ? ' ' : '';
        }
        var emptyText = document.createTextNode('');
        textNodes.push({ target: emptyText, full: full });
        return emptyText;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) {
        return document.createDocumentFragment();
      }

      var elName = node.nodeName.toLowerCase();
      var clone = (elName === 'p') ? document.createElement('span') : node.cloneNode(false);

      if (clone.attributes) {
        for (var i = clone.attributes.length - 1; i >= 0; i--) {
          var attr = clone.attributes[i];
          if (/^on/i.test(attr.name)) clone.removeAttribute(attr.name);
        }
      }

      node.childNodes.forEach(function(child) {
        clone.appendChild(cloneNodeWithEmptyText(child));
      });

      return clone;
    }

    var frag = document.createDocumentFragment();
    wrapper.childNodes.forEach(function(child) {
      frag.appendChild(cloneNodeWithEmptyText(child));
    });

    return { fragment: frag, textNodes: textNodes };
  }

  function typeInto(container, structure, speed, onDone) {
    var nodes = structure.textNodes;
    var nodeIndex = 0, charIndex = 0;

    function step() {
      while (nodeIndex < nodes.length) {
        var cur = nodes[nodeIndex];
        var full = cur.full;

        if (nodeIndex === 0 && charIndex === 0) {
          full = full.replace(/^\s+/, '');
        }
        if (nodeIndex === nodes.length - 1 && charIndex >= full.length) {
          full = full.replace(/\s+$/, '');
        }

        var chars = Array.from(full);

        if (chars.length === 0) { nodeIndex++; charIndex = 0; continue; }

        if (charIndex < chars.length) {
          cur.target.nodeValue += chars[charIndex];
          charIndex++;
          setTimeout(step, speed);
          return;
        } else {
          nodeIndex++; charIndex = 0; continue;
        }
      }
      onDone && onDone();
    }

    container.appendChild(structure.fragment);
    step();
  }

  function revealBullets(section) {
    var bullets = section.querySelectorAll('.split-hero__bullet');
    var ctas = section.querySelectorAll('.split-hero__cta-btn');
    if (!bullets.length && !ctas.length) return;

    var prefersReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (prefersReduced) {
      bullets.forEach(function(b){ b.classList.add('is-visible'); });
      ctas.forEach(function(b){ b.classList.add('is-visible'); });
      return;
    }

    bullets.forEach(function(bullet, i) {
      setTimeout(function() {
        bullet.classList.add('is-visible');
      }, 300 + i * 180);
    });

    var base = 300 + (bullets.length * 180);
    ctas.forEach(function(btn, j) {
      setTimeout(function() {
        btn.classList.add('is-visible');
      }, base + j * 180);
    });
  }

  function boot(container) {
    var scope = container || document;
    var sections = scope.querySelectorAll('.split-hero');

    sections.forEach(function(section) {
      if (section.getAttribute('data-typed-init') === 'true') return;
      section.setAttribute('data-typed-init', 'true');

      var typewriterEnabled = section.getAttribute('data-typewriter-enable') === 'true';
      var heading = section.querySelector('.split-hero__heading');
      if (!heading) { revealBullets(section); return; }

      if (!typewriterEnabled || !heading.classList.contains('has-typewriter')) {
        // No typewriter -> reveal bullets & CTAs immediately (staggered)
        revealBullets(section);
        return;
      }

      var typedSpan = heading.querySelector('.split-hero__heading-typed');
      var cursor = heading.querySelector('.split-hero__heading-cursor');
      var template = heading.querySelector('.split-hero__heading-template');
      if (!typedSpan || !cursor || !template) { revealBullets(section); return; }

      var html = (template.innerHTML || '').trim();
      if (!html) { cursor.remove(); revealBullets(section); return; }

      var speed = parseInt(section.getAttribute('data-typewriter-speed'), 10) || 40;
      var delay = parseInt(section.getAttribute('data-typewriter-delay'), 10) || 100;
      var prefersReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

      function start() {
        if (prefersReduced || speed <= 0) {
          typedSpan.innerHTML = html.replace(/<p/gi, '<span').replace(/<\/p>/gi, '</span>');
          cursor.remove();
          // Gleam effect once "done"
          typedSpan.querySelectorAll('a').forEach(function(link) { link.classList.add('link-pulse'); });
          revealBullets(section);
          return;
        }
        var structure = htmlToTypedStructure(html);
        typeInto(typedSpan, structure, speed, function() {
          cursor.remove();
          typedSpan.querySelectorAll('a').forEach(function(link) {
            link.classList.add('link-pulse');
          });
          revealBullets(section);
        });
      }

      if (delay > 0 && !prefersReduced) { setTimeout(start, delay); } else { start(); }
    });
  }

  document.addEventListener('DOMContentLoaded', function() { boot(document); });
  document.addEventListener('shopify:section:load', function(e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
